(function () {
  var DOT_RADIUS = 11;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getPaddingLeft(scrollEl) {
    var pad = 0;
    var styles = getComputedStyle(scrollEl);
    var padRaw = styles.scrollPaddingInlineStart || styles.paddingInlineStart;
    if (padRaw) {
      var parsed = parseFloat(padRaw);
      if (!isNaN(parsed)) pad = parsed;
    }
    return pad;
  }

  function getMaxScroll(scrollEl) {
    return Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
  }

  function getSnapLeft(scrollEl, item) {
    return Math.max(0, item.offsetLeft - getPaddingLeft(scrollEl));
  }

  function isStoryMobileJourney() {
    return (
      document.body.classList.contains('template-b2b-story') &&
      window.matchMedia('(max-width: 767px)').matches
    );
  }

  /** Which milestone is centered in the viewport (user drag / trackpad). */
  function getActiveIndexFromViewport(scrollEl, items) {
    if (!items.length) return 0;

    var maxScroll = getMaxScroll(scrollEl);
    if (maxScroll > 1 && scrollEl.scrollLeft >= maxScroll - 8) {
      return items.length - 1;
    }

    if (scrollEl.scrollLeft <= 8) {
      return 0;
    }

    var scrollRect = scrollEl.getBoundingClientRect();
    var focusX = scrollRect.left + scrollRect.width / 2;
    var active = 0;
    var bestDist = Infinity;

    items.forEach(function (item, index) {
      var rect = item.getBoundingClientRect();
      var itemCenterX = rect.left + rect.width / 2;
      var dist = Math.abs(itemCenterX - focusX);
      if (dist < bestDist) {
        bestDist = dist;
        active = index;
      }
    });

    return active;
  }

  function readStoredIndex(scrollEl, items) {
    var stored = parseInt(scrollEl.dataset.journeyActive, 10);
    if (isNaN(stored)) return 0;
    return Math.max(0, Math.min(stored, items.length - 1));
  }

  function storeIndex(scrollEl, index) {
    scrollEl.dataset.journeyActive = String(index);
  }

  function updateScrollPadding(scrollEl, items) {
    var list = items[0] && items[0].parentElement;

    if (!list || !items.length || isStoryMobileJourney()) {
      if (list) {
        list.style.removeProperty('padding-inline');
        list.querySelectorAll('[data-b2b-journey-spacer]').forEach(function (node) {
          node.remove();
        });
      }
      scrollEl.style.removeProperty('padding-inline');
      scrollEl.style.removeProperty('scroll-padding-inline');
      return;
    }

    var itemWidth = items[0].offsetWidth;
    var pad = Math.max(0, (scrollEl.clientWidth - itemWidth) / 2);

    list.style.removeProperty('padding-inline');
    scrollEl.style.paddingInline = '0';
    scrollEl.style.scrollPaddingInline = '0';

    list.querySelectorAll('[data-b2b-journey-spacer="start"]').forEach(function (node) {
      node.remove();
    });

    var endSpacer = list.querySelector('[data-b2b-journey-spacer="end"]');

    if (!endSpacer) {
      endSpacer = document.createElement('li');
      endSpacer.className = 'b2b-journey__spacer';
      endSpacer.setAttribute('data-b2b-journey-spacer', 'end');
      endSpacer.setAttribute('aria-hidden', 'true');
      list.appendChild(endSpacer);
    }

    endSpacer.style.width = pad + 'px';
  }

  function getCenteredScrollLeft(scrollEl, item) {
    var scrollRect = scrollEl.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var itemCenterInScroll =
      scrollEl.scrollLeft + (itemRect.left - scrollRect.left) + itemRect.width / 2;
    var maxScroll = getMaxScroll(scrollEl);
    var target = itemCenterInScroll - scrollEl.clientWidth / 2;

    return Math.max(0, Math.min(target, maxScroll));
  }

  function scrollToIndex(scrollEl, items, index, instant) {
    if (!items[index]) return;

    var maxScroll = getMaxScroll(scrollEl);
    var target;

    if (isStoryMobileJourney()) {
      if (index >= items.length - 1) {
        target = maxScroll;
      } else {
        target = Math.min(getSnapLeft(scrollEl, items[index]), maxScroll);
      }
    } else if (index === 0) {
      target = 0;
    } else if (index === items.length - 1) {
      target = maxScroll;
    } else {
      target = getCenteredScrollLeft(scrollEl, items[index]);
    }

    var behavior = instant || prefersReducedMotion() ? 'auto' : 'smooth';

    scrollEl.scrollTo({
      left: target,
      behavior: behavior,
    });
  }

  function releaseJourneyLock(scrollEl, items, dots, track, fill) {
    scrollEl.dataset.journeyLock = 'false';
    updateScrollStateAfterNav(scrollEl, items, dots, track, fill);
  }

  function getNavButtons(scrollEl) {
    var viewport = scrollEl.closest('.b2b-journey__viewport');
    return {
      viewport: viewport,
      prevBtn:
        (viewport && viewport.querySelector('[data-b2b-journey-scroll-prev]')) ||
        scrollEl.querySelector('[data-b2b-journey-scroll-prev]'),
      nextBtn:
        (viewport && viewport.querySelector('[data-b2b-journey-scroll-next]')) ||
        scrollEl.querySelector('[data-b2b-journey-scroll-next]'),
    };
  }

  function updateNavButtons(viewport, prevBtn, nextBtn, index, itemCount) {
    var atStart = index <= 0;
    var atEnd = index >= itemCount - 1;

    if (viewport) {
      viewport.classList.toggle('is-at-start', atStart);
      viewport.classList.toggle('is-at-end', atEnd);
    }

    if (prevBtn) {
      prevBtn.classList.toggle('is-hidden', atStart);
      prevBtn.setAttribute('aria-hidden', atStart ? 'true' : 'false');
    }

    if (nextBtn) {
      nextBtn.classList.toggle('is-hidden', atEnd);
      nextBtn.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
    }
  }

  function updateScrollStateAfterNav(scrollEl, items, dots, track, fill) {
    var index = readStoredIndex(scrollEl, items);
    setActiveIndex(scrollEl, items, dots, track, fill, index);

    var nav = getNavButtons(scrollEl);
    updateNavButtons(nav.viewport, nav.prevBtn, nav.nextBtn, index, items.length);
  }

  function goToIndex(scrollEl, items, dots, track, fill, index) {
    var safeIndex = Math.max(0, Math.min(index, items.length - 1));
    storeIndex(scrollEl, safeIndex);
    setActiveIndex(scrollEl, items, dots, track, fill, safeIndex);
    scrollToIndex(scrollEl, items, safeIndex);

    if (getMaxScroll(scrollEl) <= 1) {
      releaseJourneyLock(scrollEl, items, dots, track, fill);
      return;
    }

    clearTimeout(scrollEl._journeyLockRelease);
    scrollEl._journeyLockRelease = setTimeout(function () {
      if (scrollEl.dataset.journeyLock === 'true') {
        releaseJourneyLock(scrollEl, items, dots, track, fill);
      }
    }, 600);
  }

  function layoutDots(scrollEl, track, dots, items) {
    if (!track || !dots.length || !items.length) return;

    var dotCount = Math.min(dots.length, items.length);
    var lastIndex = dotCount - 1;
    var startPct = 1;
    var endPct = 99;
    var span = endPct - startPct;

    for (var i = 0; i < dotCount; i += 1) {
      var pct = lastIndex === 0 ? startPct : startPct + (i / lastIndex) * span;

      dots[i].style.visibility = 'visible';
      dots[i].style.left = pct + '%';
    }

    for (var j = dotCount; j < dots.length; j += 1) {
      dots[j].style.visibility = 'hidden';
    }
  }

  function updateFill(track, fill, dots, activeIndex, itemCount) {
    if (!fill || !track) return;

    var trackRect = track.getBoundingClientRect();
    var targetDot = dots[activeIndex];
    var useDotAnchor =
      targetDot && targetDot.style.visibility !== 'hidden';

    if (useDotAnchor) {
      var dotRect = targetDot.getBoundingClientRect();
      var endX = dotRect.left + dotRect.width / 2 - trackRect.left - DOT_RADIUS;
      fill.style.width = Math.max(0, Math.round(endX)) + 'px';
      return;
    }

    if (!itemCount || itemCount < 1) return;

    var pct = ((activeIndex + 1) / itemCount) * 100;
    fill.style.width = Math.max(0, Math.round((trackRect.width * pct) / 100)) + 'px';
  }

  function setActiveIndex(scrollEl, items, dots, track, fill, index) {
    var safeIndex = Math.max(0, Math.min(index, items.length - 1));

    items.forEach(function (item, i) {
      var isCurrent = i === safeIndex;
      item.classList.toggle('is-active', isCurrent);
      item.classList.toggle('is-passed', i < safeIndex);
      item.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });

    dots.forEach(function (dot, i) {
      if (dot.style.visibility === 'hidden') return;
      var isCurrent = i === safeIndex;
      var isPassed = i < safeIndex;
      dot.classList.toggle('is-active', isCurrent);
      dot.classList.toggle('is-passed', isPassed);
      dot.setAttribute('aria-current', isCurrent ? 'step' : 'false');
    });

    var section = scrollEl.closest('[data-b2b-journey]');
    if (section && isStoryMobileJourney()) {
      var pct = ((safeIndex + 1) / items.length) * 100;
      section.style.setProperty('--journey-progress', pct + '%');
    }

    updateFill(track, fill, dots, safeIndex, items.length);
  }

  function initJourneyReveal() {
    document.querySelectorAll('[data-b2b-journey]').forEach(function (section) {
      var header = section.querySelector('[data-b2b-journey-reveal]');
      if (!header || header.dataset.revealBound) return;

      header.dataset.revealBound = 'true';

      if (prefersReducedMotion()) {
        section.classList.add('is-revealed');
        header.classList.add('is-revealed');
        return;
      }

      if (typeof IntersectionObserver === 'undefined') {
        section.classList.add('is-revealed');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            section.classList.add('is-revealed');
            header.classList.add('is-revealed');
            observer.disconnect();
          });
        },
        { root: null, threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(header);
    });
  }

  function bindMilestoneClicks(scrollEl, items, dots, track, fill) {
    items.forEach(function (item, index) {
      if (item.dataset.itemBound) return;
      item.dataset.itemBound = 'true';

      function activate(event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        if (event.type === 'keydown') {
          event.preventDefault();
        }

        scrollEl.dataset.journeyLock = 'true';
        scrollEl.dataset.journeyUserScroll = 'false';
        goToIndex(scrollEl, items, dots, track, fill, index);
      }

      item.addEventListener('click', activate);
      item.addEventListener('keydown', activate);
    });
  }

  function initJourneyScroll() {
    document.querySelectorAll('[data-b2b-journey-scroll]').forEach(function (scrollEl) {
      var section = scrollEl.closest('[data-b2b-journey]');
      var viewport = scrollEl.closest('.b2b-journey__viewport');
      var track = section && section.querySelector('[data-b2b-journey-progress]');
      var fill = track && track.querySelector('.b2b-journey__progress-fill');
      var dots = track
        ? Array.prototype.slice.call(track.querySelectorAll('[data-b2b-journey-dot]'))
        : [];
      var items = Array.prototype.slice.call(
        scrollEl.querySelectorAll('[data-b2b-journey-item]')
      );
      var nav = getNavButtons(scrollEl);
      var prevBtn = nav.prevBtn;
      var nextBtn = nav.nextBtn;

      if (!scrollEl.dataset.journeyActive) {
        storeIndex(scrollEl, 0);
      }

      function updateScrollState(fromUserScroll) {
        var index = fromUserScroll
          ? getActiveIndexFromViewport(scrollEl, items)
          : readStoredIndex(scrollEl, items);

        if (fromUserScroll) {
          storeIndex(scrollEl, index);
        }

        setActiveIndex(scrollEl, items, dots, track, fill, index);
        updateNavButtons(viewport, prevBtn, nextBtn, index, items.length);
      }

      function measureAndUpdate() {
        updateScrollPadding(scrollEl, items);

        if (!isStoryMobileJourney()) {
          layoutDots(scrollEl, track, dots, items);
          scrollToIndex(scrollEl, items, readStoredIndex(scrollEl, items), true);
        } else if (track) {
          dots.forEach(function (dot) {
            dot.style.visibility = 'hidden';
          });
        }
        updateScrollState(false);
      }

      if (!scrollEl.dataset.bound) {
        scrollEl.dataset.bound = 'true';

        scrollEl.addEventListener(
          'scroll',
          function () {
            if (scrollEl.dataset.journeyLock === 'true') return;
            scrollEl.dataset.journeyUserScroll = 'true';
            updateScrollState(true);
          },
          { passive: true }
        );

        var unlock = function () {
          if (scrollEl.dataset.journeyLock === 'true') {
            releaseJourneyLock(scrollEl, items, dots, track, fill);
            return;
          }

          if (scrollEl.dataset.journeyUserScroll === 'true') {
            var index = getActiveIndexFromViewport(scrollEl, items);
            storeIndex(scrollEl, index);
            updateScrollStateAfterNav(scrollEl, items, dots, track, fill);
            scrollEl.dataset.journeyUserScroll = 'false';
          }
        };

        if ('onscrollend' in window) {
          scrollEl.addEventListener('scrollend', unlock, { passive: true });
        } else {
          scrollEl.addEventListener(
            'scroll',
            function () {
              if (scrollEl.dataset.journeyLock === 'true') return;
              clearTimeout(scrollEl._journeyScrollEnd);
              scrollEl._journeyScrollEnd = setTimeout(unlock, 150);
            },
            { passive: true }
          );
        }

        window.addEventListener('resize', measureAndUpdate, { passive: true });
        window.addEventListener('load', measureAndUpdate, { passive: true });

        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(measureAndUpdate);
          ro.observe(scrollEl);
          var list = scrollEl.querySelector('.b2b-journey__milestones');
          if (list) ro.observe(list);
          if (track) ro.observe(track);
        }
      }

      if (prevBtn && !prevBtn.dataset.bound) {
        prevBtn.dataset.bound = 'true';
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          var current = readStoredIndex(scrollEl, items);
          if (current > 0) {
            scrollEl.dataset.journeyLock = 'true';
            scrollEl.dataset.journeyUserScroll = 'false';
            goToIndex(scrollEl, items, dots, track, fill, current - 1);
          }
        });
      }

      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = 'true';
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          var current = readStoredIndex(scrollEl, items);
          if (current < items.length - 1) {
            scrollEl.dataset.journeyLock = 'true';
            scrollEl.dataset.journeyUserScroll = 'false';
            goToIndex(scrollEl, items, dots, track, fill, current + 1);
          }
        });
      }

      bindMilestoneClicks(scrollEl, items, dots, track, fill);

      dots.forEach(function (dot, i) {
        if (dot.dataset.dotBound) return;
        dot.dataset.dotBound = 'true';

        dot.addEventListener('click', function (event) {
          event.preventDefault();
          scrollEl.dataset.journeyLock = 'true';
          scrollEl.dataset.journeyUserScroll = 'false';
          goToIndex(scrollEl, items, dots, track, fill, i);
        });
      });

      measureAndUpdate();
      window.requestAnimationFrame(measureAndUpdate);
    });
  }

  function init() {
    initJourneyReveal();
    initJourneyScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
